export const mapPollAnswerFromApi = (resp: ApiPollAnswer): PollAnswer => {
  return {
    id: resp.id,
    isVotedByInvestor: resp.is_voted_by_investor,
    text: resp.text,
    voteCount: resp.vote_count,
  };
};

export const mapPollFromApi = (resp: ApiPoll): Poll => {
  return {
    id: resp.id,
    answers: resp.answers ? resp.answers.map(mapPollAnswerFromApi) : [],
    question: resp.question,
    totalVotes: resp.total_votes,
  };
};
